/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    EodMelcoEodModelsEodSetting,
    EodMelcoEodModelsEodSettingFromJSON,
    EodMelcoEodModelsEodSettingToJSON,
    EodMelcoModelsError,
    EodMelcoModelsErrorFromJSON,
    EodMelcoModelsErrorToJSON,
    EodMelcoModelsGenericList1MelcoEodModelsEodSetting,
    EodMelcoModelsGenericList1MelcoEodModelsEodSettingFromJSON,
    EodMelcoModelsGenericList1MelcoEodModelsEodSettingToJSON,
    EodMelcoModelsGenericList1MelcoEodModelsPartnerListItem,
    EodMelcoModelsGenericList1MelcoEodModelsPartnerListItemFromJSON,
    EodMelcoModelsGenericList1MelcoEodModelsPartnerListItemToJSON,
} from '../models';

export interface EodSettingsApiEodCreateSettingsRequest {
    eodMelcoEodModelsEodSetting?: EodMelcoEodModelsEodSetting;
}

export interface EodSettingsApiEodEditSettingsRequest {
    eodMelcoEodModelsEodSetting?: EodMelcoEodModelsEodSetting;
}

export interface EodSettingsApiEodSearchSettingsRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
}

/**
 * 
 */
export class EodSettingsApi extends runtime.BaseAPI {

    /**
     */
    async eodCreateSettingsRaw(requestParameters: EodSettingsApiEodCreateSettingsRequest): Promise<runtime.ApiResponse<EodMelcoEodModelsEodSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/eod/account/settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EodMelcoEodModelsEodSettingToJSON(requestParameters.eodMelcoEodModelsEodSetting),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EodMelcoEodModelsEodSettingFromJSON(jsonValue));
    }

    /**
     */
    async eodCreateSettings(requestParameters: EodSettingsApiEodCreateSettingsRequest): Promise<EodMelcoEodModelsEodSetting> {
        const response = await this.eodCreateSettingsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async eodDeleteSettingsRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/eod/account/settings`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async eodDeleteSettings(): Promise<void> {
        await this.eodDeleteSettingsRaw();
    }

    /**
     */
    async eodEditSettingsRaw(requestParameters: EodSettingsApiEodEditSettingsRequest): Promise<runtime.ApiResponse<EodMelcoEodModelsEodSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/eod/account/settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EodMelcoEodModelsEodSettingToJSON(requestParameters.eodMelcoEodModelsEodSetting),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EodMelcoEodModelsEodSettingFromJSON(jsonValue));
    }

    /**
     */
    async eodEditSettings(requestParameters: EodSettingsApiEodEditSettingsRequest): Promise<EodMelcoEodModelsEodSetting> {
        const response = await this.eodEditSettingsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async eodGetSettingsRaw(): Promise<runtime.ApiResponse<EodMelcoEodModelsEodSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/eod/account/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EodMelcoEodModelsEodSettingFromJSON(jsonValue));
    }

    /**
     */
    async eodGetSettings(): Promise<EodMelcoEodModelsEodSetting> {
        const response = await this.eodGetSettingsRaw();
        return await response.value();
    }

    /**
     */
    async eodPartnersRaw(): Promise<runtime.ApiResponse<EodMelcoModelsGenericList1MelcoEodModelsPartnerListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/eod/settings/partner`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EodMelcoModelsGenericList1MelcoEodModelsPartnerListItemFromJSON(jsonValue));
    }

    /**
     */
    async eodPartners(): Promise<EodMelcoModelsGenericList1MelcoEodModelsPartnerListItem> {
        const response = await this.eodPartnersRaw();
        return await response.value();
    }

    /**
     */
    async eodSearchSettingsRaw(requestParameters: EodSettingsApiEodSearchSettingsRequest): Promise<runtime.ApiResponse<EodMelcoModelsGenericList1MelcoEodModelsEodSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/eod/account/settings/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EodMelcoModelsGenericList1MelcoEodModelsEodSettingFromJSON(jsonValue));
    }

    /**
     */
    async eodSearchSettings(requestParameters: EodSettingsApiEodSearchSettingsRequest): Promise<EodMelcoModelsGenericList1MelcoEodModelsEodSetting> {
        const response = await this.eodSearchSettingsRaw(requestParameters);
        return await response.value();
    }

}
